module.exports = __webpack_public_path__ + "static/media/megabank.b5b72362.svg";